import { Button, Card, Image, Pagination, Spin, Typography } from "antd";
import { UploadCloud } from "lucide-react";
import React, { useState } from "react";
import { useGetMyImages } from "~/services/image";
import { getImageUrl } from "~/utils";
import { SortOrder } from "~/utils/constants";

const { Text } = Typography;

interface RecentPhotosProps {
  onPreviewPhoto: (imageUrl: string, title: string) => void;
}

const RecentPhotos: React.FC<RecentPhotosProps> = ({ onPreviewPhoto }) => {
  const [page, setPage] = useState(1);
  const { data: photos, isLoading } = useGetMyImages({
    page,
    pageSize: 6,
    sortByCreatedAt: SortOrder.DESC,
  });

  return (
    <Card
      classNames={{
        body: "p-0",
      }}
    >
      <div className="p-4 border-b">
        <Text strong>Recent Photos</Text>
      </div>
      <div className="p-4">
        <Spin spinning={isLoading}>
          <div className="grid grid-cols-3 gap-4">
            {photos && photos.items.length > 0 ? (
              <>
                {photos.items.map((image) => (
                  <div
                    key={image.id}
                    className="aspect-square bg-gray-100 rounded-lg relative group overflow-hidden"
                  >
                    <Image
                      src={getImageUrl(image.url)}
                      alt={image.name || "Photo"}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <Button
                        type="text"
                        className="text-white"
                        onClick={() =>
                          onPreviewPhoto(
                            getImageUrl(image.url),
                            image.name || "Photo"
                          )
                        }
                      >
                        View
                      </Button>
                    </div>
                  </div>
                ))}
                <div className="col-span-3">
                  <Pagination
                    total={photos?.meta.totalItems || 0}
                    current={page}
                    pageSize={6}
                    showSizeChanger={false}
                    hideOnSinglePage
                    onChange={(page) => setPage(page)}
                  />
                </div>
              </>
            ) : (
              <div className="col-span-3 text-center py-8 text-gray-500">
                <UploadCloud size={36} className="mx-auto mb-2" />
                <p>No photos yet. Click "New Photo" to add some.</p>
              </div>
            )}
          </div>
        </Spin>
      </div>
    </Card>
  );
};

export default RecentPhotos;
